import CalendarContainer from "@legacy/calendar/CalendarContainer"

import { faIcon } from "@utils/faIcon"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

export default function Calendar() {
    return (
        <AppFrame.Root pageId="Calendar">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageTitle
                            label="Calendar"
                            icon={faIcon({ name: "objects-align-left", style: "solid" })}
                        />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <CalendarContainer />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
